/*
* This file contain reducer's state for all actions that are related to templates
*/
import _ from 'lodash';

const initialState = {
  items: [],
  isFetched: false,
  isFetching: true,
  isUpdatingParams: false,
  isUploadingFile: false,
  paramsUpdated: true,
  newTemplateAdded: false
};

function onTemplateUpdateSuccess(state, action) {
  let items = _.clone(state.items);
  _.remove(items, { _id: action.updatedDoc._id });

  items.push(action.updatedDoc);

  items = _.sortBy(items, 'title');

  return Object.assign({}, state, {
    items: items,
    isUpdatingParams: false,
    isUploadingFile: false,
    paramsUpdated: true
  });
}

export default function templates(state = initialState, action) {

  switch(action.type) {
    case 'TEMPLATES_FETCH_REQUEST':
      return Object.assign({}, state, {
        items: [],
        isFetching: true
      });

    case 'TEMPLATES_FETCH_SUCCESS':
      return Object.assign({}, state, {
        items: action.templates,
        isFetching: false,
        isFetched: true
      });

    case 'TEMPLATES_FETCH_FAILURE':
      return Object.assign({}, state, {
        items: [],
        isFetching: false,
        isFetched: false,
        error: action.error,
        errorMessage: action.errorMessage
      });

    case 'TEMPLATE_PARAMS_UPDATE_REQUEST':
      return Object.assign({}, state, {
        isUpdatingParams: true
      });

    case 'TEMPLATE_PARAMS_UPDATE_SUCCESS':
      return onTemplateUpdateSuccess(state, action);

    case 'TEMPLATE_PARAMS_UPDATE_FAILURE':
      return Object.assign({}, state, {
        isUpdatingParams: false,
        paramsUpdated: false,
        error: action.error,
        errorMessage: action.errorMessage
      });

    case 'TEMPLATE_FILE_UPLOAD_REQUEST':
      return Object.assign({}, state, {
        isUploadingFile: true,
      });

    case 'TEMPLATE_FILE_UPLOAD_FAILURE':
      return Object.assign({}, state, {
        isUploadingFile: false,
      });

    case 'TEMPLATE_FILE_UPLOAD_SUCCESS':
      return onTemplateUpdateSuccess(state, action);

    case 'ADD_NEW_TEMPLATES_REQUEST':
      return Object.assign({}, state, {
        newTemplateUpdateRequest: true,
      });

    case 'ADD_NEW_TEMPLATES_SUCCESS': 
      return Object.assign({}, state, {
        newTemplateUpdateRequest: false,
        newTemplateAdded: true,
      });

    case 'ADD_NEW_TEMPLATES_UNSET_FLAG':
      return Object.assign({}, state, {
        newTemplateAdded: false,
      });

      case 'SAVE_TEMPLATE_SET_SUCCESS':
      return Object.assign({}, state, {
        items: [...state.items, ...action.response.newTmpSet.templates]
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Reducers/templates.js